import { Booking, BookingTypes } from "src/types/apps/booking";
import { ColorVariation } from "./eventColors";

export default (item: Booking) => {

    let color = 'default'
    if (item.is_coaching_booking) {
        color = ColorVariation?.[3].eColor
    } else {
        if (item.booking_type === BookingTypes.OwnerMadeBooking) {
            color = ColorVariation?.[2].eColor
        } else if (item.booking_type === BookingTypes.UserMadeBooking) (
            color = ColorVariation?.[1].eColor
        )
    }

    const booking = {
        title: item?.booking_name,
        allDay: false,
        start: item?.start,
        end: item?.end,
        color: color,
        booking: item
    }

    return booking
}